/**
 * dcent-search-bar.js — 공용 검색줄 동작 (drop-03 W0).
 *
 * 원본 `<label>` 래핑을 버린 대가로 두 가지를 JS 가 맡는다:
 *   1) 컨테이너 아무 데나 클릭 → input 포커스 (원본의 label 동작)
 *   2) 입력 중에만 X(지우기) 표시 + X 클릭 시 값 비우기
 * `<label>` 안에 `<button>`(X·submit)은 HTML 사양상 무효 중첩이라 원본 구조를 그대로 옮길 수 없다.
 *
 * 포커스 시 보라 보더·흰 배경은 CSS `:focus-within` 이 처리한다(JS 0).
 * X 는 값을 비운 뒤 `input` 이벤트를 버블로 디스패치한다 — 소비처는 커스텀 이벤트를 배울 필요 없이
 * 자기 `input` 리스너 하나만 유지하면 된다. **제출·이동은 하지 않는다.**
 *
 * 로드는 소비 섹션 책임: <script src="{{ 'dcent-search-bar.js' | asset_url }}" type="module" defer></script>
 * 모듈이므로 최상위 `return` 을 쓰지 않는다(ESM 에서 SyntaxError: Illegal return statement).
 *
 * 양 샵 byte-identical — assets/dcent-* 는 parity 게이트 분모다.
 * 사용자 노출 문자열 0 — 카피는 전부 Liquid 가 `| t` 로 서버 렌더한다.
 */

/** 검색줄 1개 초기화. 재호출 안전(멱등 가드). */
export function initSearchBar(el) {
  if (!el || el.__dcentSearchBarBound) return;
  el.__dcentSearchBarBound = true;

  const input = el.querySelector("[data-dcent-search-input]");
  if (!input) return;
  const clear = el.querySelector("[data-dcent-search-clear]");

  const syncClear = () => {
    if (clear) clear.hidden = input.value === "";
  };
  syncClear();

  input.addEventListener("input", syncClear);

  if (clear) {
    clear.addEventListener("click", () => {
      input.value = "";
      syncClear();
      input.focus();
      input.dispatchEvent(new Event("input", { bubbles: true }));
    });
  }

  // 컨테이너 클릭 위임 — 원본 <label> 대체. 버튼·인풋 자체 클릭은 그대로 둔다.
  el.addEventListener("click", (e) => {
    if (e.target.closest("button, input")) return;
    input.focus();
  });
}

/** 범위 안 모든 검색줄 초기화. 늦게 붙인 마크업에도 그대로 쓴다(가드가 있어 재바인드 안전). */
export function initSearchBars(root = document) {
  root.querySelectorAll("[data-dcent-search-bar]").forEach(initSearchBar);
}

if (typeof document !== "undefined") {
  document.addEventListener("DOMContentLoaded", () => initSearchBars());
}
